/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Observable, of, tap, shareReplay } from 'rxjs';
import { CacheItem } from '../models/cache-item.model';

export class CacheService<T> {
    private cache: Map<string, CacheItem<T>> = new Map();

    public get(key: string, observable: Observable<T>): Observable<T> {
        const cacheItem = this.cache.get(key);

        if (cacheItem) {
            if (cacheItem.status === 'loaded') {
                return of(cacheItem.data!);
            } else if (cacheItem.status === 'loading') {
                return cacheItem.observable!;
            }
        }

        const loadingObservable = observable.pipe(
            tap(data => this.set(key, data)),
            shareReplay(1)
        );

        this.cache.set(key, {
            status: 'loading',
            observable: loadingObservable
        });

        return loadingObservable;
    }

    public set(key: string, value: T): void {
        this.cache.set(key, this.createCacheItem(value));
    }

    private createCacheItem(value: T): CacheItem<T> {
        return {
            status: 'loaded',
            data: value
        };
    }
}
